/* ============================================================
   ELVA GLOBAL JS — faithful port of elva-homepage.html scripts
   Cart, Wishlist, Search, Nav scroll, Collections reveal,
   Product card rendering, Fly-to-cart, Community drag carousel
   ============================================================ */
  // COLLECTIONS REVEAL
  const collectionsData = {
    men: {
      title: "Men's Collections",
      cats: [
        { label: "Tops",      name: "T-Shirts & Polos",   img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&q=80" },
        { label: "Bottoms",   name: "Shorts",              img: "https://images.unsplash.com/photo-1591337676887-a217a6970a8a?w=800&q=80" },
        { label: "Bottoms",   name: "Pants & Trousers",   img: "https://images.unsplash.com/photo-1617196034183-421b4040ed20?w=800&q=80" },
        { label: "Outerwear", name: "Jackets & Hoodies",  img: "https://images.unsplash.com/photo-1544441893-675973e31985?w=800&q=80" }
      ]
    },
    women: {
      title: "Women's Collections",
      cats: [
        { label: "Tops",      name: "Blouses & Tees",     img: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=800&q=80" },
        { label: "Bottoms",   name: "Dresses",             img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80" },
        { label: "Bottoms",   name: "Pants & Leggings",   img: "https://images.unsplash.com/photo-1516826957135-700dedea698c?w=800&q=80" },
        { label: "Outerwear", name: "Jackets & Coats",    img: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=800&q=80" }
      ]
    }
  };



  // HERO SLIDER
  let heroIdx = 0;
  const heroTrack = document.getElementById('heroTrack');
  const heroDots = document.querySelectorAll('.hero-dot');
  const heroSlides = document.querySelectorAll('.hero-slide');
  function heroGo(i) {
    heroIdx = i;
    heroTrack.style.transform = `translateX(-${heroIdx * 100}%)`;
    heroDots.forEach((d,j) => d.classList.toggle('active', j===i));
  }
  function heroMove(dir) { heroGo((heroIdx + dir + heroSlides.length) % heroSlides.length); }
  setInterval(() => heroMove(1), 5500);

  // PRODUCT CAROUSELS
  const carouselState = {};
  function carouselMove(id, dir) {
    const track = document.getElementById(id);
    const cards = track.querySelectorAll('.product-card');
    const total = cards.length;
    if (!carouselState[id]) carouselState[id] = 0;
    const visible = Math.floor(track.parentElement.offsetWidth / track.querySelector('.product-card').offsetWidth);
    const max = total - visible;
    carouselState[id] = Math.max(0, Math.min(max, carouselState[id] + dir));
    const pct = (carouselState[id] / total) * 100;
    track.style.transform = `translateX(-${pct}%)`;
  }

  // ── WISHLIST ──
  const WISHLIST_KEY = 'elva_wishlist';
  let wishlistItems = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');

  function saveWishlist() { localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlistItems)); }

  function isWishlisted(name, color) {
    return wishlistItems.some(i => i.name === name && i.color === color);
  }

  function toggleWishlist(btn) {
    const item = {
      name: btn.dataset.name,
      color: btn.dataset.color,
      price: parseFloat(btn.dataset.price),
      img: btn.dataset.img,
      handle: btn.dataset.handle || ''
    };
    const idx = wishlistItems.findIndex(i => i.name === item.name && i.color === item.color);
    let added;
    if (idx > -1) {
      wishlistItems.splice(idx, 1);
      added = false;
    } else {
      wishlistItems.push(item);
      added = true;
    }
    saveWishlist();
    document.querySelectorAll(`.wishlist-heart[data-name="${cssEscape(item.name)}"][data-color="${cssEscape(item.color)}"]`)
      .forEach(el => el.classList.toggle('active', added));
    showWishlistToast(added);
  }

  function cssEscape(str) {
    return String(str).replace(/(["\\])/g, '\\$1');
  }

  function initWishlistHearts(scope) {
    (scope || document).querySelectorAll('.wishlist-heart').forEach(el => {
      el.classList.toggle('active', isWishlisted(el.dataset.name, el.dataset.color));
    });
  }

  function showWishlistToast(added) {
    let toast = document.getElementById('wishlistToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlistToast';
      toast.style.cssText = `
        position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%) translateY(20px);
        background: var(--black); color: var(--white);
        padding: 13px 26px; border-radius: 50px;
        font-size: 12px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase;
        z-index: 9999; opacity: 0; transition: opacity 0.3s ease, transform 0.3s ease;
        box-shadow: 0 8px 24px rgba(0,0,0,0.2); pointer-events: none; white-space: nowrap;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = added ? '♥ Added to Wishlist' : 'Removed from Wishlist';
    clearTimeout(toast._hideTimer);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    toast._hideTimer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
    }, 1800);
  }


  function openCart() {
    document.getElementById('cartDrawer').classList.add('open');
    document.getElementById('cartOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.getElementById('cartDrawer').classList.remove('open');
    document.getElementById('cartOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  // ── MOBILE NAV DRAWER ──
  function openMobNav() {
    document.querySelector('.mob-menu-btn').classList.add('open');
    document.querySelector('.mob-menu-btn').setAttribute('aria-expanded', 'true');
    document.getElementById('mobNavDrawer').classList.add('open');
    document.getElementById('mobOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobNav() {
    document.querySelector('.mob-menu-btn').classList.remove('open');
    document.querySelector('.mob-menu-btn').setAttribute('aria-expanded', 'false');
    document.getElementById('mobNavDrawer').classList.remove('open');
    document.getElementById('mobOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }
  function toggleMobNav() {
    var drawer = document.getElementById('mobNavDrawer');
    if (drawer.classList.contains('open')) closeMobNav();
    else openMobNav();
  }

  function quickAddFromCard(el) {
    const card = el.closest('.product-card');
    const variantId = card ? card.dataset.variantId : null;
    if (variantId) {
      addToCart({ id: variantId, quantity: 1 });
      return;
    }
    // Fallback for non-Shopify-wired cards
    const name = card.querySelector('.product-name')?.textContent || 'Elva Product';
    console.warn('quickAddFromCard: no variant id found on card', name);
  }

  // ── Shopify Ajax Cart ──
  function addToCart(items) {
    const payload = Array.isArray(items) ? { items } : { items: [items] };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => r.json())
      .then(() => renderCart())
      .then(() => openCart())
      .catch(err => console.error('Add to cart failed:', err));
  }

  // ── Add Membership Now (cart drawer upsell button) ──
  // Same login-gating as the membership page: guests get sent to sign in/create an account
  // instead of silently adding a membership to a guest cart, so it can actually be recognized
  // against their account later (see account-dashboard.liquid's is_member detection).
  function wireCartMembershipButton() {
    var btn = document.getElementById('cartAddMembershipBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      if (btn.dataset.requiresLogin === 'true') {
        window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname);
        return;
      }
      var errorEl = document.getElementById('cartAddMembershipError');
      if (errorEl) errorEl.style.display = 'none';
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '…';

      // Selling plan is only sent once a subscription app has attached one to this
      // product (see the liquid comment above cartAddMembershipBtn). Until then this
      // adds the membership as a normal one-time product.
      var membershipItem = { id: parseInt(btn.dataset.variantId, 10), quantity: 1 };
      if (btn.dataset.sellingPlanId) {
        membershipItem.selling_plan = parseInt(btn.dataset.sellingPlanId, 10);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [membershipItem] })
      })
        .then(function(res) {
          if (!res.ok) { return res.json().then(function(data) { throw new Error(data.description || 'Add to cart failed'); }); }
          return res.json();
        })
        .then(function() {
          // Membership is in the cart — send the shopper straight to Shopify checkout
          // instead of reopening the drawer, so they can pay immediately. This checks
          // out the membership together with anything else already in their cart.
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('Add membership (cart drawer) error:', err);
          btn.disabled = false;
          btn.textContent = originalText;
          if (errorEl) errorEl.style.display = 'block';
        });
    });
  }
  wireCartMembershipButton();

  // ── Membership note reveal ──
  // The "Get Started" toggle in the member note keeps the Add Membership button
  // tucked away until the shopper actually asks to see it.
  function toggleMemberNote() {
    var toggle = document.getElementById('memberNoteToggle');
    var reveal = document.getElementById('cartMembershipReveal');
    if (!toggle || !reveal) return;
    var isOpen = reveal.classList.contains('open');
    var willOpen = !isOpen;
    reveal.classList.toggle('open', willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) {
      // Let the reveal take up its layout space first, then bring it into view
      // inside the cart drawer's own scroll — scrollIntoView finds that scrollable
      // ancestor automatically, so this doesn't touch the page behind the drawer.
      requestAnimationFrame(function() {
        reveal.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }

  // ── Membership section fade-up reveal (cart drawer) ──
  // elva-scroll-reveal.js deliberately skips anything inside a fixed/sticky
  // container — it watches the page viewport, and the cart drawer scrolls
  // internally instead. Same fade-up feel as the manifesto hero, just scoped
  // to the drawer's own scroll container (#cartBody) so it actually fires.
  (function () {
    var memberSection = document.querySelector('.member-section');
    var scrollRoot = document.getElementById('cartBody');
    if (!memberSection || !scrollRoot) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      memberSection.classList.add('revealed');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          memberSection.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { root: scrollRoot, threshold: 0.35 });
    io.observe(memberSection);
  })();

  function renderCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const body = document.getElementById('cartItems');
        const empty = document.getElementById('cartEmpty');
        const count = cart.item_count;

        document.getElementById('cartBadge').textContent = count;
        const navBadge = document.getElementById('navBadge');
        if (navBadge) {
          navBadge.textContent = count;
          navBadge.classList.toggle('is-zero', count === 0);
        }
        document.getElementById('cartTotal').textContent = '$' + (cart.total_price / 100).toFixed(0);

        empty.style.display = cart.items.length ? 'none' : 'flex';
        const cartBodyEl = document.getElementById('cartBody');
        if (cartBodyEl) cartBodyEl.classList.toggle('is-empty', !cart.items.length);
        if (cart.items.length) {
          var checkoutMsg = document.getElementById('checkoutEmptyMsg');
          if (checkoutMsg) checkoutMsg.classList.remove('show');
        }

        body.innerHTML = cart.items.map((item, idx) => `
          <div class="cart-item">
            <img class="cart-item-img" src="${item.image}" alt="${item.product_title}">
            <div class="cart-item-info">
              <div class="cart-item-name">${item.product_title}</div>
              <div class="cart-item-variant">${item.variant_title || ''}</div>
              <div class="cart-qty-row">
                <button class="qty-btn" onclick="changeCartQty(${item.key ? "'" + item.key + "'" : item.id}, -1)">−</button>
                <span class="qty-num">${item.quantity}</span>
                <button class="qty-btn" onclick="changeCartQty(${item.key ? "'" + item.key + "'" : item.id}, 1)">+</button>
              </div>
            </div>
            <div class="cart-item-price">
              <span class="ip-new">$${(item.final_line_price / 100).toFixed(0)}</span>
            </div>
            <button class="cart-remove" onclick="removeCartItem(${item.key ? "'" + item.key + "'" : item.id})">✕</button>
          </div>
        `).join('');

        // Unlock progress (free hat threshold — adjust UNLOCK_THRESHOLD as needed)
        const UNLOCK_THRESHOLD = 350; // dollars
        const unlockText = document.getElementById('unlockText');
        const unlockFill = document.getElementById('unlockFill');
        if (unlockText && unlockFill) {
          const spent = cart.total_price / 100;
          const remaining = Math.max(0, UNLOCK_THRESHOLD - spent);
          const pct = Math.min(100, (spent / UNLOCK_THRESHOLD) * 100);
          unlockFill.style.width = pct + '%';
          unlockText.textContent = remaining > 0
            ? 'Add $' + remaining.toFixed(0) + ' more to unlock a free hat!'
            : "You've unlocked a free hat! 🎉";
        }
      })
      .catch(err => console.error('Render cart failed:', err));
  }

  // ── Checkout guard ──
  // Shopify itself bounces an empty cart straight back off /checkout, which reads as
  // a broken button. This checks first and shows a message under the button instead.
  function handleCheckoutClick() {
    var btn = document.getElementById('cartCheckoutBtn');
    var msg = document.getElementById('checkoutEmptyMsg');
    if (btn) btn.disabled = true;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (btn) btn.disabled = false;
        if (!cart.item_count) {
          if (msg) {
            msg.classList.remove('show');
            void msg.offsetWidth; // restart the shake animation on repeat clicks
            msg.classList.add('show');
          }
          return;
        }
        if (msg) msg.classList.remove('show');
        window.location.href = '/checkout';
      })
      .catch(function() {
        if (btn) btn.disabled = false;
        // If the cart can't be checked, fall back to letting Shopify handle it.
        window.location.href = '/checkout';
      });
  }

  function toggleUnlock() {
    const bar = document.getElementById('unlockBar');
    const toggle = document.getElementById('unlockToggle');
    const willClose = !bar.classList.contains('closed');
    bar.classList.toggle('closed', willClose);
    toggle.classList.toggle('closed', willClose);
  }

  function changeCartQty(lineKey, dir) {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const line = cart.items.find(i => (i.key || i.id) === lineKey);
      if (!line) return;
      const newQty = Math.max(1, line.quantity + dir);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      }).then(() => renderCart());
    });
  }
  function removeCartItem(lineKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(() => renderCart());
  }

  // Initialize badge count on load
  renderCart();

  // Nav: transparent while hero visible, solid white otherwise
  (function() {
    const nav  = document.querySelector('nav');
    const hero = document.getElementById('hero');

    function checkNav() {
      if (!hero) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      // Only transparent when hero is actually in view AND we've scrolled at least 1px
      // (so on page load with scrollY=0 it stays solid white)
      const overHero = heroBottom > 100 && window.scrollY > 0;

      nav.style.background        = overHero ? 'transparent' : '';
      nav.style.borderBottomColor = overHero ? 'transparent' : '';

      const links = nav.querySelectorAll('.nav-left a, .cart-btn');
      links.forEach(el => el.style.color = overHero ? '#ffffff' : '');

      const icons = nav.querySelectorAll('.nav-right svg');
      icons.forEach(el => el.style.stroke = overHero ? '#ffffff' : '');

      const paths = nav.querySelectorAll('svg path');
      paths.forEach(el => el.style.fill = overHero ? '#ffffff' : '');
    }
    window.addEventListener('scroll', checkNav, { passive: true });
    // Run immediately after DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkNav);
    } else {
      checkNav();
    }
  })();


  // ── SEARCH ──
  // Featured suggestions are now server-rendered in theme.liquid from the
  // merchant's chosen collection (Theme settings → Search), so this just
  // opens the panel and focuses the input.
  function openSearch(){
    document.getElementById('srchOverlay').classList.add('open');
    document.body.style.overflow='hidden';
    setTimeout(()=>document.getElementById('srchInput').focus(),140);
  }

  function closeSrch(){
    const o=document.getElementById('srchOverlay');
    o.classList.remove('open');
    setTimeout(()=>{
      document.getElementById('srchInput').value='';
      document.getElementById('srchResults').classList.remove('show');
      document.getElementById('srchDefaultLeft').classList.remove('hide');
    },420);
    document.body.style.overflow='';
  }

  function fillSrch(v){
    document.getElementById('srchInput').value=v;
    runSrch(v);
  }

  let srchDebounce;
  function runSrch(q){
    const defPanel = document.getElementById('srchDefaultLeft');
    const res      = document.getElementById('srchResults');
    const count    = document.getElementById('srchCount');
    const grid     = document.getElementById('srchGrid');
    const showAll  = document.getElementById('srchShowAll');

    if(!q.trim()){
      defPanel.classList.remove('hide');
      res.classList.remove('show');
      return;
    }
    defPanel.classList.add('hide');

    clearTimeout(srchDebounce);
    srchDebounce = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
        .then(r => r.json())
        .then(d => {
          const m = (d.resources && d.resources.results && d.resources.results.products) || [];

          count.textContent = m.length
            ? m.length + ' result' + (m.length>1?'s':'') + ' for "' + q + '"'
            : 'No results for "' + q + '"';

          const shown = m.slice(0,4);
          grid.innerHTML = shown.length
            ? shown.map(p=>`
                <a class="srch-card" href="${p.url}" data-handle="${p.handle||''}">
                  <div class="srch-card-img-wrap">
                    <img class="srch-card-img img-primary" src="${p.featured_image ? p.featured_image.url : ''}" alt="${p.title}">
                    <img class="srch-card-img img-hover" data-hover-slot src="${p.featured_image ? p.featured_image.url : ''}" alt="${p.title}">
                  </div>
                  <div class="srch-card-name">${p.title}</div>
                  <div class="srch-card-cat">${p.variants && p.variants[0] ? p.variants[0].option1 || '' : ''}</div>
                  <div class="srch-card-price">${p.price_min !== undefined ? '$' + parseFloat(p.price_min).toFixed(2) : ''}</div>
                </a>`).join('')
            : '';

          /* The predictive search API only returns one image per product, so
             the true "second image" for the hover-swap is fetched separately
             per visible card. Falls back to no swap if this ever fails. */
          shown.forEach(p => {
            if (!p.handle) return;
            fetch('/products/' + p.handle + '.js')
              .then(r => r.json())
              .then(full => {
                if (full.images && full.images.length > 1) {
                  const img = grid.querySelector('a[data-handle="' + p.handle + '"] [data-hover-slot]');
                  if (img) img.src = full.images[1];
                }
              })
              .catch(() => {});
          });

          if(m.length > 4){
            showAll.style.display = 'inline-flex';
            showAll.href = '/search?q=' + encodeURIComponent(q);
            showAll.innerHTML = `View all ${m.length} results <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>`;
          } else {
            showAll.style.display = 'none';
          }

          res.classList.add('show');
        }).catch(()=>{});
    }, 250);
  }

  document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeSrch(); });

function getVisibleNew() { return window.innerWidth <= 1024 ? 2 : 4; }

function bindSwatchEvents(grid) {
  // Swatch clicks — Rule 1 + Rule 2 (verbatim from original makeCardHtml wiring)
  grid.querySelectorAll('.product-card').forEach(card => {
    const imgPrimary  = card.querySelector('.img-primary');
    const imgHover    = card.querySelector('.img-hover');
    const colorLabel  = card.querySelector('.card-color');
    card.querySelectorAll('.swatch').forEach(s => {
      s.addEventListener('click', function(e) {
        e.preventDefault(); // don't navigate when clicking swatch
        e.stopPropagation();
        // ── Activate swatch ──
        card.querySelectorAll('.swatch').forEach(x => x.classList.remove('active'));
        this.classList.add('active');
        // ── Rule 1: swap card images ──
        const newImg  = this.dataset.img;
        const newImg2 = this.dataset.img2;
        if (newImg && imgPrimary) {
          imgPrimary.style.transition = 'opacity 0.3s ease';
          imgPrimary.style.opacity = '0';
          setTimeout(() => {
            imgPrimary.src = newImg;
            imgPrimary.style.opacity = '1';
          }, 160);
        }
        if (newImg2 && imgHover) {
          imgHover.src = newImg2;
        }
        // ── Rule 2: update color label + product page link ──
        const colorName = this.dataset.color || '';
        if (colorLabel) colorLabel.textContent = colorName;
        // Keep the mobile swipeable gallery (if this card has one turned on,
        // e.g. Complete The Look on mobile) in sync with the newly picked color.
        if (this.dataset.images) {
          try { gpSetCardGallery(card, JSON.parse(this.dataset.images)); } catch (err) {}
        }
        const basePath = card.getAttribute('href').split('?')[0];
        // Use Shopify's native ?variant= so the product page picks the right
        // variant server-side (correct color/gallery/price from first paint,
        // no client-side patch needed, no risk of mixed-color galleries)
        if (this.dataset.variantId) {
          card.href = basePath + '?variant=' + this.dataset.variantId;
          card.dataset.variantId = this.dataset.variantId;
        }
        // ── Rule 3: keep the Quick Add size row in sync with the new color ──
        if (this.dataset.sizesJson) {
          try {
            var sizesForColor = JSON.parse(this.dataset.sizesJson);
            var qaSizes = card.querySelector('.qa-sizes');
            if (qaSizes) {
              sizesForColor.forEach(function(sv) {
                var selector = '.qa-sbtn[data-size="' + (window.CSS && CSS.escape ? CSS.escape(String(sv.size)) : String(sv.size)) + '"]';
                var qaBtn = qaSizes.querySelector(selector);
                if (!qaBtn) return;
                if (sv.id) { qaBtn.dataset.variantId = sv.id; } else { qaBtn.removeAttribute('data-variant-id'); }
                qaBtn.classList.toggle('sold-out', !sv.available);
              });
            }
          } catch (err) { /* malformed size data — leave buttons as they were */ }
        }
      });
    });
  });
}

/* ── MOBILE SWIPEABLE GALLERY ──
   Shared by every card that uses snippets/product-card.liquid. Moved here
   (from gender-shop.liquid, the only place that used to load it) so any
   page/section can opt a card grid into the gallery — via its own
   .cim-desktop{display:none}/.cim-mobile{display:block} mobile rule, e.g.
   .ctl-grid in elva-product.css for Complete The Look — and get the same
   working swipe, drag, and dot-sync behavior the Gender page has. */
function gpSetCardGallery(card, urls) {
  var wrap = card.querySelector('.cim-mobile');
  var track = card.querySelector('.mgallery-track');
  var dots = card.querySelector('.mgallery-dots');
  if (!wrap || !track || !urls || !urls.length) return;
  track.innerHTML = urls.map(function(u) {
    return '<div class="mgallery-slide"><img src="' + u + '" loading="lazy" alt="" draggable="false"></div>';
  }).join('');
  track.scrollLeft = 0;
  if (urls.length > 1) {
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'mgallery-dots';
      wrap.appendChild(dots);
    }
    dots.innerHTML = urls.map(function(_, i) {
      return '<span class="mgallery-dot' + (i === 0 ? ' active' : '') + '"></span>';
    }).join('');
  } else if (dots) {
    dots.innerHTML = '';
  }
}
/* Keep the active dot in sync while the shopper swipes — scroll doesn't
   bubble, so this listens in the capture phase on the document to catch
   scroll on any .mgallery-track without binding one listener per card. */
document.addEventListener('scroll', function(e) {
  var track = e.target && e.target.closest && e.target.closest('.mgallery-track');
  if (!track) return;
  var dots = track.parentElement ? track.parentElement.querySelectorAll('.mgallery-dot') : null;
  if (!dots || !dots.length || !track.clientWidth) return;
  var idx = Math.round(track.scrollLeft / track.clientWidth);
  dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
}, { capture: true, passive: true });

/* ── MOUSE-CURSOR DRAG for the gallery — covers desktop browsers switched
   to a mobile viewport/emulation, where there's no real touch input to
   swipe with. Real touch keeps using native CSS scroll-snap panning as-is;
   this only kicks in for mouse/pen pointers. ── */
(function() {
  var drag = null; /* { track, card, startX, startScrollLeft, moved, pointerId } */
  var THRESHOLD = 6;
  var settleRAF = null;

  /* Smoothly animates scrollLeft to `target` with an ease-out curve — driven
     entirely by us so it feels the same in every browser, rather than
     relying on native scrollTo({behavior:'smooth'}), which varies in
     duration/easing and can visibly fight scroll-snap re-engaging mid-flight. */
  function gpAnimateScrollTo(track, target, onDone) {
    if (settleRAF) { cancelAnimationFrame(settleRAF); settleRAF = null; }
    var duration = 340;
    var start = track.scrollLeft;
    var change = target - start;
    if (Math.abs(change) < 0.5) { track.scrollLeft = target; if (onDone) onDone(); return; }
    var startTime = null;
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function step(ts) {
      if (startTime === null) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      track.scrollLeft = start + change * easeOutCubic(progress);
      if (progress < 1) {
        settleRAF = requestAnimationFrame(step);
      } else {
        settleRAF = null;
        if (onDone) onDone();
      }
    }
    settleRAF = requestAnimationFrame(step);
  }

  document.addEventListener('dragstart', function(e) {
    if (e.target.closest && e.target.closest('.product-card')) e.preventDefault();
  });

  document.addEventListener('pointerdown', function(e) {
    if (e.pointerType === 'touch') return; /* real touch already works via native scrolling */
    var track = e.target.closest && e.target.closest('.mgallery-track');
    if (!track) return;
    if (settleRAF) { cancelAnimationFrame(settleRAF); settleRAF = null; }
    drag = {
      track: track,
      card: track.closest('.product-card'),
      startX: e.clientX,
      startScrollLeft: track.scrollLeft,
      moved: false,
      pointerId: e.pointerId
    };
    track.setPointerCapture(e.pointerId);
    track.classList.add('mgallery-dragging');
    document.body.classList.add('mgallery-dragging');
  });

  document.addEventListener('pointermove', function(e) {
    if (!drag || e.pointerId !== drag.pointerId) return;
    var dx = e.clientX - drag.startX;
    if (Math.abs(dx) > THRESHOLD) drag.moved = true;
    drag.track.scrollLeft = drag.startScrollLeft - dx;
  });

  function gpEndGalleryDrag(e) {
    if (!drag || e.pointerId !== drag.pointerId) return;
    document.body.classList.remove('mgallery-dragging');
    var track = drag.track, card = drag.card, moved = drag.moved;
    /* figure out which slide we've ended up closest to */
    var w = track.clientWidth || 1;
    var idx = Math.round(track.scrollLeft / w);
    idx = Math.max(0, Math.min(idx, track.children.length - 1));
    var target = idx * w;
    if (moved) {
      /* keep scroll-snap disabled through the whole glide so it can't fight
         our animation — only re-engage it once we've actually landed */
      gpAnimateScrollTo(track, target, function() {
        track.classList.remove('mgallery-dragging');
      });
      /* a genuine drag shouldn't also navigate to the product page */
      if (card) {
        var suppress = function(ev) { ev.preventDefault(); ev.stopPropagation(); };
        card.addEventListener('click', suppress, { capture: true, once: true });
        setTimeout(function() { card.removeEventListener('click', suppress, true); }, 0);
      }
    } else {
      /* plain click/tiny jitter — snap back instantly, no visible nudge */
      track.classList.remove('mgallery-dragging');
      track.scrollLeft = target;
    }
    drag = null;
  }
  document.addEventListener('pointerup', gpEndGalleryDrag);
  document.addEventListener('pointercancel', gpEndGalleryDrag);
})();

function updateSlideNew(totalCount, offset, gridId, sectionId) {
  const grid = document.getElementById(gridId);
  if (!grid) return;
  const visible = getVisibleNew();
  const gap = 16;
  const outer = grid.parentElement;
  const cardWidth = (outer.offsetWidth - gap * (visible - 1)) / visible;
  const shift = offset * (cardWidth + gap);
  grid.style.transform = `translateX(-${shift}px)`;
  const maxOffset = totalCount - visible;
  const section = document.getElementById(sectionId);
  if (section) {
    const prev = section.querySelector('.carousel-btn.prev');
    const next = section.querySelector('.carousel-btn.next');
    if (prev) prev.style.opacity = offset === 0 ? '0.35' : '1';
    if (next) next.style.opacity = offset >= maxOffset ? '0.35' : '1';
  }
}

// ── INIT ──
function openCollections(gender) {
    // Scroll target handled by the onclick inline; this highlights the correct panel
    var panels = document.querySelectorAll('.split-panel');
    panels.forEach(function(p) { p.style.outline = 'none'; });
    if (panels.length >= 2) {
      var idx = gender === 'women' ? 1 : 0;
      panels[idx].style.outline = '3px solid #fff';
      setTimeout(function(){ panels[idx].style.outline = 'none'; }, 1200);
    }
  }
  window.addEventListener('resize', () => {
  var bsGrid = document.getElementById('bsProductsGrid');
  var nrGrid = document.getElementById('nrProductsGrid');
  if (bsGrid) { window.bsOffset = 0; updateSlideNew(bsGrid.querySelectorAll('.product-card').length, 0, 'bsProductsGrid', 'bsSection'); }
  if (nrGrid) { window.nrOffset = 0; updateSlideNew(nrGrid.querySelectorAll('.product-card').length, 0, 'nrProductsGrid', 'nrSection'); }
});
(function() {
  let qaAnimating = false;

  /* ─── Core fly-to-cart trigger ───
     Runs the real /cart/add.js call for the card's currently-selected variant
     in parallel with the flight animation, then reconciles with the real cart
     at impact time — no more fake badge counts. */
  function flyToCart(quickAddEl, e, variantIdOverride) {
    if (qaAnimating) return;

    const card = quickAddEl.closest('.product-card');
    const variantId = variantIdOverride || (card ? card.dataset.variantId : null);
    if (!variantId) return;

    const addPromise = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function(res) {
      if (!res.ok) { return res.json().then(function(data) { throw new Error(data.description || 'Add to cart failed'); }); }
      return res.json();
    });

    qaAnimating = true;

    const btn = quickAddEl;
    btn.classList.add('qa-animating');

    // ── RIPPLE on click point ──
    const btnRect = btn.getBoundingClientRect();
    const rx = e ? (e.clientX - btnRect.left) : btnRect.width / 2;
    const ry = e ? (e.clientY - btnRect.top)  : btnRect.height / 2;
    const rip = document.createElement('div');
    rip.className = 'qa-ripple';
    rip.style.cssText = `width:${btnRect.width*2}px;height:${btnRect.width*2}px;left:${rx - btnRect.width}px;top:${ry - btnRect.width}px`;
    btn.appendChild(rip);
    setTimeout(() => rip.remove(), 600);

    // ── Get product image from card (already resolved above) ──
    const imgEl = card ? card.querySelector('.img-primary, .product-img-wrap img') : null;
    const imgRect = imgEl ? imgEl.getBoundingClientRect() : btnRect;
    const imgSrc  = imgEl ? imgEl.src : '';

    // ── Get cart badge target ──
    const cartBadgeEl = document.getElementById('navBadge');
    const cartBadgeRect = cartBadgeEl.getBoundingClientRect();
    const destX = cartBadgeRect.left + cartBadgeRect.width / 2;
    const destY = cartBadgeRect.top  + cartBadgeRect.height / 2;

    // ── Flying clone setup ──
    const clone = document.getElementById('flyCloneGlobal');
    const cloneImg = document.getElementById('flyCloneImg');
    cloneImg.src = imgSrc;

    const side = Math.min(imgRect.width, imgRect.height) * 0.38;
    const W = side, H = side;

    clone.style.cssText = `
      position:fixed;
      left:${imgRect.left + imgRect.width/2 - W/2}px;
      top:${imgRect.top  + imgRect.height/2 - H/2}px;
      width:${W}px; height:${H}px;
      border-radius:8px; overflow:hidden;
      pointer-events:none; z-index:99999;
      opacity:0;
      transform:scale(1) rotate(0deg);
      will-change:transform,opacity,border-radius;
      box-shadow:0 4px 18px rgba(0,0,0,0.12);
      transform-origin:center center;
      transition:none;
    `;

    // Phase 1 – lift & morph to circle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        clone.style.transition = [
          'opacity 140ms ease-out',
          'transform 260ms cubic-bezier(0.2,0,0.1,1)',
          'box-shadow 260ms ease',
          'border-radius 280ms cubic-bezier(0.4,0,0.2,1)'
        ].join(', ');
        clone.style.opacity = '1';
        clone.style.transform = 'scale(1.06) rotate(-2deg) translateY(-12px)';
        clone.style.boxShadow = '0 20px 52px rgba(0,0,0,0.22), 0 4px 12px rgba(0,0,0,0.1)';
        clone.style.borderRadius = '50%';
      });
    });

    // Phase 2 – arc flight
    setTimeout(() => {
      const startL = parseFloat(clone.style.left);
      const startT = parseFloat(clone.style.top);
      const dx = (destX - W * 0.18) - startL;
      const dy = (destY - H * 0.18) - startT;
      const cpY = Math.min(-Math.abs(dy) * 0.5, -90);
      const duration = 720;
      const startTime = performance.now();

      clone.style.transition = 'none';

      // Orbit ring
      const flyRing = document.getElementById('flyRingGlobal');
      flyRing.style.cssText = `
        position:fixed; pointer-events:none; z-index:99998;
        border-radius:50%;
        border:1px solid rgba(17,17,17,0.2);
        width:${W * 1.28}px; height:${H * 1.28}px;
        opacity:0;
        left:${startL + W/2}px; top:${startT + H/2}px;
        transform:translate(-50%,-50%) scale(0.8);
        transition:opacity 180ms ease, transform 200ms ease;
      `;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          flyRing.style.opacity = '1';
          flyRing.style.transform = 'translate(-50%,-50%) scale(1)';
        });
      });

      function ease(t) {
        return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2;
      }

      function tick(now) {
        const elapsed = now - startTime;
        const raw = Math.min(elapsed / duration, 1);
        const t = ease(raw);
        const u = 1 - t;

        const midX = startL + dx * 0.18;
        const midY = startT + dy * 0.15 + cpY;
        const x = u*u*startL + 2*u*t*midX + t*t*(startL + dx);
        const y = u*u*startT + 2*u*t*midY + t*t*(startT + dy);

        const scale   = 1.06 - (1.06 - 0.32) * t;
        const rotate  = -2 + t * 14;
        const opacity = t > 0.75 ? 1 - ((t - 0.75) / 0.25) * 0.7 : 1;
        const shadow  = t > 0.6 ? 0 : (1 - t / 0.6);

        clone.style.left      = x + 'px';
        clone.style.top       = y + 'px';
        clone.style.transform = `scale(${scale}) rotate(${rotate}deg)`;
        clone.style.opacity   = opacity;
        clone.style.boxShadow = `0 ${shadow*20}px ${shadow*48}px rgba(0,0,0,${shadow*0.2})`;

        flyRing.style.left   = (x + W/2) + 'px';
        flyRing.style.top    = (y + H/2) + 'px';
        flyRing.style.width  = (W * 1.28 * scale) + 'px';
        flyRing.style.height = (H * 1.28 * scale) + 'px';
        flyRing.style.opacity = String(opacity * 0.7);

        if (raw < 1) {
          requestAnimationFrame(tick);
        } else {
          flyRing.style.transition = 'opacity 100ms ease';
          flyRing.style.opacity = '0';
          onCartImpact(btn);
        }
      }
      requestAnimationFrame(tick);
    }, 340);

    // Phase 3 – cart impact. Waits for the real /cart/add.js result before
    // celebrating, so the animation always reflects what actually happened.
    function onCartImpact(btn) {
      clone.style.transition = 'opacity 80ms ease';
      clone.style.opacity = '0';

      addPromise.then(function() {
        // ── Success: real item is in the cart — sync drawer/badges/total from real state ──
        renderCart();

        // Cart icon bounce – nav cart svg
        const cartSvgEl = document.querySelector('nav .cart-btn');
        if (cartSvgEl) {
          cartSvgEl.style.display = 'inline-flex';
          cartSvgEl.style.animation = 'none';
          void cartSvgEl.offsetHeight;
          cartSvgEl.animate([
            { transform: 'scale(1)' },
            { transform: 'scale(1.28) translateY(-2px)' },
            { transform: 'scale(0.96)' },
            { transform: 'scale(1.07)' },
            { transform: 'scale(1)' }
          ], { duration: 420, easing: 'cubic-bezier(0.36,0.07,0.19,0.97)' });
        }

        // Pulse ring at cart
        const ring = document.getElementById('pulseRingGlobal');
        ring.style.cssText = `
          position:fixed; pointer-events:none; z-index:99998;
          border-radius:50%; border:1.5px solid rgba(17,17,17,0.4);
          width:0; height:0; opacity:0;
          left:${destX}px; top:${destY}px;
          transform:translate(-50%,-50%);
          animation:qaPulseExpand 450ms cubic-bezier(0,0,.2,1) forwards;
        `;

        // Badge bump flourish (renderCart() above already set the real numbers —
        // this just replays the little pop animation on top of them)
        const badge = document.getElementById('navBadge');
        if (badge) {
          badge.style.animation = 'none';
          void badge.offsetHeight;
          badge.animate([
            { transform: 'translateY(8px) scale(.7)', opacity: '0' },
            { transform: 'translateY(-2px) scale(1.15)', opacity: '1' },
            { transform: 'translateY(0) scale(1)', opacity: '1' }
          ], { duration: 380, easing: 'cubic-bezier(0.34,1.56,0.64,1)', fill: 'forwards' });
        }

        // Button → "Added ✓"
        // Swap only the .qa-label text — btn is the whole .quick-add box, which
        // now also contains the .qa-sizes buttons, so writing to btn.textContent
        // directly would wipe them out.
        const labelEl = btn.querySelector('.qa-label') || btn;
        const prevText = labelEl.textContent.trim();
        btn.style.transition = 'background 200ms ease';
        labelEl.textContent = '✓ Added';
        btn.classList.remove('qa-error');
        btn.classList.add('qa-added');
        btn.classList.remove('qa-open');

        setTimeout(() => {
          labelEl.textContent = prevText;
          btn.classList.remove('qa-added');
          btn.classList.remove('qa-animating');
          qaAnimating = false;
        }, 1600);
      })
      .catch(function(err) {
        // ── Failure (sold out, network error, etc.): no fake success ──
        console.error('Quick add failed:', err);
        const flyRingEl = document.getElementById('flyRingGlobal');
        if (flyRingEl) flyRingEl.style.opacity = '0';

        const labelEl = btn.querySelector('.qa-label') || btn;
        const prevText = labelEl.textContent.trim();
        labelEl.textContent = 'Try again';
        btn.classList.add('qa-error');

        setTimeout(() => {
          labelEl.textContent = prevText;
          btn.classList.remove('qa-error');
          btn.classList.remove('qa-animating');
          qaAnimating = false;
        }, 1800);
      });
    }
  }

  /* ─── Delegate click on any .quick-add, anywhere it appears (homepage
     carousels, shop grids, recommendations, order-confirmation upsells,
     complete-the-look) — previously scoped to specific section classes,
     which silently dropped several placements ─── */
  document.addEventListener('click', function(e) {
    const qa = e.target.closest('.quick-add');
    if (!qa) return;

    // A size button handles its own click via quickAddSize() (see below) and
    // already calls stopPropagation, so this delegate won't normally see it —
    // this check is just a safety net.
    if (e.target.closest('.qa-sbtn')) return;

    e.preventDefault();
    e.stopPropagation();

    // Product has sizes: clicking the "+ Quick Add" label itself can't know
    // which size to add, so reveal the size row instead (same thing hovering
    // does on desktop) — this is what makes Quick Add work on touch/trackpad
    // where :hover never fires. Only add straight to cart when there's no
    // size to choose in the first place.
    if (qa.dataset.hasSizes === 'true') {
      qa.classList.toggle('qa-open');
      return;
    }

    flyToCart(qa, e);
  });

  /* A specific size was clicked inside a Quick Add panel — add THAT exact
     color+size variant, instead of whatever the card's "current" variant was. */
  window.quickAddSize = function(btn) {
    if (!btn || btn.classList.contains('sold-out')) return;
    const variantId = btn.dataset.variantId;
    if (!variantId || variantId === 'null') return;
    const qa = btn.closest('.quick-add');
    const card = btn.closest('.product-card');
    if (card) card.dataset.variantId = variantId; // keep card/PDP link in sync, same as a swatch click
    if (qa) qa.classList.remove('qa-open');
    flyToCart(qa, null, variantId);
  };

  /* Quick Add uses the card's current variant ID (set/updated by swatch clicks).
     flyToCart() now performs the real add-to-cart itself, so this just triggers
     it — kept as a named function in case any markup calls it directly. */
  window.quickAddFromCard = function(el) {
    flyToCart(el, null);
  };

})();

/* ─── COMMUNITY CAROUSEL ─── */
(function() {
  const TILE_HEIGHT = 560;
  const track = document.getElementById('communityTrack');
  const outer = document.getElementById('communityOuter');
  const sourceTemplate = document.getElementById('communitySource');
  // The Community section only exists on the homepage / manifesto page
  // (see templates/index.json, templates/page.manifesto.json) — every other
  // template (product, gender, collection, etc.) has neither #communityTrack
  // nor #communityOuter. Without this guard, track.appendChild(...) below
  // throws on those pages, which — since this is one shared <script> file —
  // silently kills every bit of JS defined AFTER this block for the rest of
  // the page load: the footer country selector, the mobile footer accordion,
  // and (most visibly) the mouse/touch drag-to-scroll setup for product
  // carousels near the bottom of this file. That's why "Recommended For You"
  // on the product page couldn't be dragged even though its CSS/markup is
  // otherwise identical to "New Releases" on the homepage.
  if (!track || !outer) return;
  const COPIES = 3, GAP = 10, SPEED_PX_PER_SEC = 70;

  const FALLBACK_PHOTOS = [
    { src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=700&q=85', alt: 'Mountain terrace morning' },
    { src: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=700&q=85', alt: 'Lakeside scenic view' },
    { src: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=700&q=85', alt: 'City skyline at sunset' },
    { src: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=700&q=85', alt: 'Yacht on the ocean' },
    { src: 'https://images.unsplash.com/photo-1499678329028-101435549a4e?w=700&q=85', alt: 'Beach aerial lifestyle' },
    { src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=700&q=85', alt: 'Alpine summit view' },
    { src: 'https://images.unsplash.com/photo-1515859005217-8a1f08870f59?w=700&q=85', alt: 'Superyacht deck' },
    { src: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=700&q=85', alt: 'Private jet window view' }
  ];

  function makeImgTile(photo) {
    const div = document.createElement('div');
    div.className = 'community-tile';
    div.dataset.type = 'image';
    const img = document.createElement('img');
    img.src = photo.src; img.alt = photo.alt; img.loading = 'lazy';
    div.appendChild(img);
    return div;
  }

  // Prefer real tiles (image or video) rendered server-side by the section/blocks.
  const sourceTiles = sourceTemplate
    ? Array.from(sourceTemplate.content.querySelectorAll('.community-tile'))
    : [];

  function cloneTile(tile) {
    const clone = tile.cloneNode(true);
    clone.style.height = TILE_HEIGHT + 'px';
    const video = clone.querySelector('video');
    if (video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      // Playback is handed off to the IntersectionObserver set up below,
      // instead of every clone calling .play() the instant it's created.
      video.removeAttribute('autoplay');
    }
    return clone;
  }

  if (sourceTiles.length) {
    for (let c = 0; c < COPIES; c++) sourceTiles.forEach(t => track.appendChild(cloneTile(t)));
  } else {
    for (let c = 0; c < COPIES; c++) FALLBACK_PHOTOS.forEach(p => {
      const tile = makeImgTile(p);
      tile.style.height = TILE_HEIGHT + 'px';
      track.appendChild(tile);
    });
  }

  /* The carousel triples every tile (COPIES = 3) for the seamless loop, so a
     single video block becomes 3 independent <video> elements. Autoplaying
     all 3 at once — including the ones sitting off-screen — is what was
     stalling/degrading playback on phones: mobile devices support far fewer
     concurrent decoding video streams than desktop. This only lets the copy
     that's actually visible inside the carousel play; the rest stay paused. */
  const communityVideos = track.querySelectorAll('video');
  if (communityVideos.length) {
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { root: outer, rootMargin: '0px 150px', threshold: 0.15 });
      communityVideos.forEach(v => videoObserver.observe(v));
    } else {
      // Very old browsers without IntersectionObserver support: fall back
      // to the original "just play everything" behavior.
      communityVideos.forEach(v => {
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
    }
  }

  const setLength = sourceTiles.length || FALLBACK_PHOTOS.length;

  function getSetWidth() {
    const tiles = track.querySelectorAll('.community-tile');
    let w = 0;
    for (let i = 0; i < setLength; i++) w += tiles[i].getBoundingClientRect().width + GAP;
    return w;
  }

  let setW = 0, animPos = 0, rafId = null, lastTime = null, paused = false;
  let isDragging = false, dragStartX = 0, dragStartPos = 0;
  let dragVelocity = 0, lastDragX = 0, lastDragTime = 0, momentumId = null;

  function step(timestamp) {
    if (lastTime === null) lastTime = timestamp;
    const dt = (timestamp - lastTime) / 1000;
    lastTime = timestamp;
    if (!isDragging && !paused) animPos -= SPEED_PX_PER_SEC * dt;
    if (animPos < -setW) animPos += setW;
    if (animPos > 0)     animPos -= setW;
    track.style.transform = `translateX(${animPos}px)`;
    rafId = requestAnimationFrame(step);
  }

  function init() {
    setW = getSetWidth(); animPos = 0; lastTime = null;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(step);
  }

  window.addEventListener('resize', () => { setW = getSetWidth(); });

  outer.addEventListener('mouseenter', () => { paused = true; });
  outer.addEventListener('mouseleave', () => { if (!isDragging) { paused = false; lastTime = null; } });

  outer.addEventListener('mousedown', (e) => {
    isDragging = true; dragStartX = e.clientX; dragStartPos = animPos;
    lastDragX = e.clientX; lastDragTime = performance.now(); dragVelocity = 0;
    outer.classList.add('dragging');
    if (momentumId) cancelAnimationFrame(momentumId);
  });
  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const now = performance.now(), dt = now - lastDragTime, dx = e.clientX - lastDragX;
    if (dt > 0) dragVelocity = dx / (dt / 1000);
    lastDragX = e.clientX; lastDragTime = now;
    animPos = dragStartPos + (e.clientX - dragStartX);
    if (animPos < -setW) animPos += setW;
    if (animPos > 0)     animPos -= setW;
  });
  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false; outer.classList.remove('dragging'); paused = false; lastTime = null;
    let vel = dragVelocity * 0.3, lastM = performance.now();
    function momentum(now) {
      const dt = (now - lastM) / 1000; lastM = now;
      vel *= Math.pow(0.88, dt * 60); animPos += vel * dt;
      if (animPos < -setW) animPos += setW;
      if (animPos > 0)     animPos -= setW;
      if (Math.abs(vel) > 2) momentumId = requestAnimationFrame(momentum);
    }
    momentumId = requestAnimationFrame(momentum);
  });

  let touchStartX = 0, touchStartPos = 0, touchLastX = 0, touchLastTime = 0, touchVel = 0;
  outer.addEventListener('touchstart', (e) => {
    const t = e.touches[0]; isDragging = true;
    touchStartX = t.clientX; touchStartPos = animPos;
    touchLastX = t.clientX; touchLastTime = performance.now(); touchVel = 0;
    if (momentumId) cancelAnimationFrame(momentumId);
    e.preventDefault();
  }, { passive: false });
  outer.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const t = e.touches[0], now = performance.now(), dt = now - touchLastTime, dx = t.clientX - touchLastX;
    if (dt > 0) touchVel = dx / (dt / 1000);
    touchLastX = t.clientX; touchLastTime = now;
    animPos = touchStartPos + (t.clientX - touchStartX);
    if (animPos < -setW) animPos += setW;
    if (animPos > 0)     animPos -= setW;
    e.preventDefault();
  }, { passive: false });
  outer.addEventListener('touchend', () => {
    isDragging = false; paused = false; lastTime = null;
    let vel = touchVel * 0.25, lastM = performance.now();
    function touchMomentum(now) {
      const dt = (now - lastM) / 1000; lastM = now;
      vel *= Math.pow(0.88, dt * 60); animPos += vel * dt;
      if (animPos < -setW) animPos += setW;
      if (animPos > 0)     animPos -= setW;
      if (Math.abs(vel) > 2) momentumId = requestAnimationFrame(touchMomentum);
    }
    momentumId = requestAnimationFrame(touchMomentum);
  });

  requestAnimationFrame(() => requestAnimationFrame(init));
})();

/* ─── COUNTRY SELECTOR (footer) ─── */
(function detectCountry() {
  var flagEl = document.getElementById('countryFlag');
  var nameEl = document.getElementById('countryName');
  if (!flagEl || !nameEl) return;
  fetch('https://ipapi.co/json/')
    .then(r => r.json())
    .then(d => {
      const code = d.country_code || 'GB';
      const name = d.country_name || 'United Kingdom';
      const flag = code.toUpperCase().replace(/./g, c => String.fromCodePoint(c.charCodeAt(0) + 127397));
      flagEl.textContent = flag;
      nameEl.textContent = name;
      document.querySelectorAll('.c-item').forEach(el => {
        if (el.textContent.includes(name)) el.style.background = 'rgba(255,255,255,0.06)';
      });
    })
    .catch(() => {
      flagEl.textContent = '🇬🇧';
      nameEl.textContent = 'United Kingdom';
    });
})();

function toggleCountryDropdown() {
  document.getElementById('countryDropdown').classList.toggle('open');
}

function selectCountry(code, flag, name) {
  document.getElementById('countryFlag').textContent = flag;
  document.getElementById('countryName').textContent = name;
  document.getElementById('countryDropdown').classList.remove('open');
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.country-selector')) {
    const d = document.getElementById('countryDropdown');
    if (d) d.classList.remove('open');
  }
});

/* ─── MOBILE FOOTER ACCORDION + GENDER TOGGLE ─── */
(function() {
  document.querySelectorAll('.mob-acc-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.mob-acc-item');
      var panel = item.querySelector('.mob-acc-panel');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.mob-acc-item').forEach(function(i) {
        i.querySelector('.mob-acc-trigger').setAttribute('aria-expanded', 'false');
        i.querySelector('.mob-acc-panel').style.maxHeight = '0';
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  document.querySelectorAll('.mob-gender-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mob-gender-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
})();

/* ─── MOUSE DRAG-TO-SCROLL FOR PRODUCT CAROUSELS + TRENDING COLLECTIONS ───
   New Releases, Best Sellers and Recommended For You all share the same
   .products-track-outer row. Trending Collections uses .collections-grid —
   same story: on a real phone it scrolls natively via touch swipe once the
   mobile layout kicks in (overflow-x:auto — see the max-width:1024px blocks
   in elva-main.css / elva-mobile.css / elva-product.css). A mouse has no
   swipe gesture, so anyone viewing that same mobile-width layout from a
   desktop browser (theme editor's mobile preview, a resized window, a
   trackpad-less mouse) had no way to pan the row by hand.

   This adds click-and-drag panning for mouse input, using the same plain
   mousedown / window-mousemove / window-mouseup pattern as the community
   carousel above (deliberately NOT the Pointer Events + setPointerCapture
   API — capturing the pointer on the track element interfered with the
   click event's real target resolution, so a plain click on a card no
   longer navigated at all). Listening on window for move/up, like the
   carousel above does, keeps click resolution on the actual card element
   untouched. It only engages once the row is actually in its scrollable
   (mobile) layout, so desktop's arrow-button carousel / 3-col grid is never
   affected. */
(function() {
  function enableDragScroll(track) {
    if (track.dataset.dragScrollBound) return;
    track.dataset.dragScrollBound = 'true';

    var isDown = false, startX = 0, startScroll = 0, moved = false;

    track.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return; // left button only
      // Only takes over once the mobile CSS made this row scrollable; on
      // desktop it's overflow:hidden/grid and the prev/next buttons (or
      // static columns) handle it.
      if (getComputedStyle(track).overflowX !== 'auto') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('drag-scrolling');
      // Stops the press-and-move from also being read as "start selecting
      // text" or "start dragging this image" by the browser itself.
      e.preventDefault();
    });

    // Belt-and-suspenders on top of the CSS (-webkit-user-drag/pointer-events
    // on the images): if a browser ever still tries to kick off a native
    // HTML5 drag on a card or its image, kill it outright so it can never
    // turn into the "ghost image" drag instead of a smooth scroll.
    track.addEventListener('dragstart', function(e) { e.preventDefault(); });

    window.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });

    window.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('drag-scrolling');
    });

    // A drag that actually moved the row shouldn't also register as a click
    // on the product card / swatch underneath the cursor when released.
    track.addEventListener('click', function(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function bindAllDragScrollTracks() {
    document.querySelectorAll('.products-track-outer, .collections-grid').forEach(enableDragScroll);
  }

  bindAllDragScrollTracks();
  // Re-scan when a merchant adds one of these sections live in the theme editor.
  document.addEventListener('shopify:section:load', bindAllDragScrollTracks);
})();